// Single source of truth for project priority — used by Projects list,
// Project Detail, Project dialog, and Work Scheduler.

export const PRIORITY_OPTIONS = ["Urgent", "Important", "High", "Low"];

export const PRIORITY_META = {
  Urgent:    { bg: "#FEE2E2", fg: "#991B1B", dot: "#DC2626", border: "#DC2626" },
  Important: { bg: "#FFEDD5", fg: "#9A3412", dot: "#EA580C", border: "#EA580C" },
  High:      { bg: "#FEF3C7", fg: "#92400E", dot: "#D97706", border: "#D97706" },
  Low:       { bg: "#F3F4F6", fg: "#4B5563", dot: "#9CA3AF", border: "#E5E7EB" },
};

// Lower rank = more urgent (use for sort: ascending).
export const PRIORITY_RANK = { Urgent: 0, Important: 1, High: 2, Low: 3 };

export function PriorityBadge({ priority, size = "sm" }) {
  const p = priority || "Low";
  const meta = PRIORITY_META[p] || PRIORITY_META.Low;
  const pad = size === "xs" ? "px-1.5 py-0.5 text-[9px]" : "px-2 py-0.5 text-[10px]";
  return (
    <span
      className={`inline-flex items-center gap-1 ${pad} uppercase tracking-widest font-bold`}
      style={{ backgroundColor: meta.bg, color: meta.fg }}
      data-testid={`priority-badge-${p.toLowerCase()}`}
    >
      <span className="inline-block w-1.5 h-1.5 rounded-full" style={{ backgroundColor: meta.dot }} />
      {p}
    </span>
  );
}

export function PriorityDot({ priority }) {
  const meta = PRIORITY_META[priority || "Low"] || PRIORITY_META.Low;
  return (
    <span
      className="inline-block w-2 h-2 rounded-full shrink-0"
      style={{ backgroundColor: meta.dot }}
      title={priority || "Low"}
      data-testid={`priority-dot-${(priority || "Low").toLowerCase()}`}
    />
  );
}
